module.exports = __webpack_public_path__ + "static/media/bim-yangzhikangfu.b9be69e8.png";